export default __webpack_public_path__ + "static/cloud-sharing-web-app-cover-deea5d25e75c44f560ebb21add40ba53.png";